export default __webpack_public_path__ + "static/media/3e2235e440d225efa67063c8158e588e.svg";